const features = [
  {
    icon: 'ri-hd-line',
    title: '超清画质 流畅不卡',
    desc: '全站1080P高清资源，多线路智能切换，无论手机还是电脑都能享受流畅观影体验，告别缓冲等待。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新 同步热播',
    desc: '专业内容团队全天候更新，院线新片、热播剧集第一时间上线，日均更新50+部影片，追剧快人一步。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '免费安全 无需注册',
    desc: '无需注册登录，无需付费充值，打开即看。全站无弹窗广告干扰，纯净观影环境，保障您的隐私安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-foreground-500 text-sm">为什么几百万影迷选择蘑菇影院免费在线观看？</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-2xl p-8 text-center border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100/80 text-primary-600 mx-auto mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-2">{feat.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}